import { apiAxios } from '@/api/axios';
import type {
  CarrierSummary,
  CommoditySummary,
  CustomerSummary,
  VehicleSummary,
} from '@/api/types/Registry';

// Registry autocomplete services — consume `/api/{customers|carriers|vehicles}`
// (§4.3). Each call accepts a free-text query and returns a server-trimmed
// result list (Pagination.AUTOCOMPLETE_LIMIT on the api).

export const searchCustomers = async (query: string): Promise<CustomerSummary[]> => {
  const response = await apiAxios.get<CustomerSummary[]>('/api/customers', {
    params: query ? { query } : undefined,
  });
  return response.data;
};

export const searchCarriers = async (query: string): Promise<CarrierSummary[]> => {
  const response = await apiAxios.get<CarrierSummary[]>('/api/carriers', {
    params: query ? { query } : undefined,
  });
  return response.data;
};

export const searchVehicles = async (query: string): Promise<VehicleSummary[]> => {
  const response = await apiAxios.get<VehicleSummary[]>('/api/vehicles', {
    params: query ? { query } : undefined,
  });
  return response.data;
};

// Commodity registry autocomplete (CHR-04 / ADR-0043) — consumes
// `/api/commodities` (mirror of carriers). Blank query → top-N alphabetical;
// non-blank → case-insensitive substring. Server-trimmed (AUTOCOMPLETE_LIMIT).
export const searchCommodities = async (
  query: string,
): Promise<CommoditySummary[]> => {
  const response = await apiAxios.get<CommoditySummary[]>('/api/commodities', {
    params: query ? { query } : undefined,
  });
  return response.data;
};
